/* eslint-disable */
import React from 'react';
import { Auth0Client } from '@auth0/auth0-spa-js';
import { extLocalStore } from 'util/localStorage';
import { PROVIDERS } from 'appConstants';
import { sendToLogger } from 'logger';
import config from 'config';

const customPopup = () => {
	const popUpWindowWidth = 400;
	const popUpWindowHeight = 600;
	const horizontalOffset = popUpWindowWidth / 2;
	const y = window.outerHeight / 2 + window.screenY - popUpWindowHeight / 2;
	const x = window.outerWidth + window.screenX - (popUpWindowWidth + horizontalOffset);
	return window.open(
		null,
		null,
		`width=${popUpWindowWidth}, height=${popUpWindowHeight}, top=${y}, left=${x}`
	);
};

export let auth0Client;

const auth0PopupTimeoutSeconds = 90;

export const useAuth0 = (user) => {
	const [auth0ClientInitiated, setAuth0ClientInitiated] = React.useState(false);

	const configureAuth0Client = (auth0) => {
		if (auth0) {
			const {
				auth: { serverUrl, organization, iamRegion = 'US' }
			} = auth0;
			const { clientId, domain } = config.auth0[iamRegion];
			const iamDomain = serverUrl ? serverUrl.split('://')[1] : domain;
			extLocalStore.setItem('domain', iamDomain);

			auth0Client = new Auth0Client({
				organization,
				domain: iamDomain,
				client_id: clientId,
				scope: config.auth0.scope,
				audience: config.auth0.audience,
				responseType: 'code id_token',
				useRefreshTokens: true,
				cacheLocation: 'localstorage'
			});
			/**
			 * auth0 is a flag set to true for users who log in via IAM.
			 * This flag is used to swap auth-tokens in axios-request-interceptor (see util/Api/config.js)
			 */
			extLocalStore.auth0 = true;

			setAuth0ClientInitiated(true);
		}
	};

	React.useEffect(
		() => {
			const cachedProviders = extLocalStore.getItem(PROVIDERS);
			const cachedAuth0Provider = (cachedProviders || []).find((auth) => auth.authType === 'AUTH0');
			const auth0 = user.auth0Provider || cachedAuth0Provider;
			configureAuth0Client(auth0);
		},
		[user.authProviders]
	);

	async function authenticate(username, loginCallback, popupErrorCallback) {
		if (auth0Client) {
			try {
				await auth0Client.loginWithPopup(
					{ redirect_uri: null, max_age: 0, login_hint: username },
					{ popup: customPopup(), timeoutInSeconds: auth0PopupTimeoutSeconds }
				);
				if (loginCallback) {
					loginCallback();
				}
			} catch (error) {
				sendToLogger({
					level: 'fatal',
					message: {
						message: 'Auth0 authenticate error',
						userAgent: window.location.userAgent,
						err: error
					}
				});
				if (error.popup) {
					error.popup.close();
				}
				popupErrorCallback(error);
			}
		}
	}

	const login = ({ auth0, loginCallback, popupErrorCallback, username = '' }) => {
		/**
		 * onLogin flag is set to true for users who log in via IAM.
		 * This flag will help prevent authentication for the rare case where
		 * the user has logged out, attempts to log back, and the Auth0-SDK
		 * provides valid access token. -Amir
		 */
		extLocalStore.onLogin = true;

		configureAuth0Client(auth0);

		return authenticate(username, loginCallback, popupErrorCallback);
	};

	return {
		auth0ClientInitiated,
		login
	};
};
